import CommonIcon from '_c/common-icon'
import { showTitle } from '@/libs/util'
export default {
  components: {
    CommonIcon
  },
  methods: {
    showTitle (item) {
      return showTitle(item, this)
    },
    showChildren (item) {
      return item.children && (item.children.length > 1 || (item.meta && item.meta.showAlways))
    },
    getNameOrHref (item, children0) {
      if (item.href) return `isTurnByHref_${item.href}`
      else {
        if (children0) {
          if (item.children && item.children[0].children && item.children[0].children.length === 1) {
            return item.children[0].children[0].name
          } else {
            return item.children[0].name
          }
        } else {
          return item.name
        }
      }
    },
    getKey (item) {
      if (item.children && item.children[0].children && item.children[0].children.length === 1) {
        return `menu-${item.children[0].children[0].name}`
      } else {
        return `menu-${item.children[0].name}`
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/main/components/side-menu/mixin.js